export default [{
    text: 'Будни',
    value: 'weekdays'
}, {
    text: 'Выходные',
    value: 'weekends'
}, {
    text: 'Ежедневно',
    value: 'everyday'
}];
